
<div v-if="visible" ref="confirm" class="cp-confirm">
  <div class="box-mask">
    <div class="box-container">
      <div class="close" @click="handleAction('cancel')"></div>
      <div class="box-title">
        <span :data-text="title">{{ title }}</span>
      </div>
      <div class="box-content">{{ text }}</div>
      <div class="box-bottom">
        <div class="bottom-item" @click="handleAction('yes')"></div>
        <div class="bottom-item cancel" @click="handleAction('cancel')"></div>
      </div>
    </div>
  </div>
</div>
